<template>
  <span>
    {{ convertedAmount }}&nbsp;{{ usedDstCurrency }}
    <DataGetter
      contentId="rates"
      @dataAvailable="
        data => {
          rates = data.metaData
        }
      "
    />
    <DataGetter
      contentId="storeData"
      @dataAvailable="
        data => {
          storeData = data?.metaData || {}
        }
      "
    />

    <EventListener
      :events="[
        'user_connected',
        'user_disconnected',
        'user_location_date_changed',
        'user_updated',
      ]"
      @user_connected="loadLocalUserCurrency"
      @user_disconnected="loadLocalUserCurrency"
      @user_updated="loadLocalUserCurrency"
      @user_location_date_changed="loadLocalUserCurrency"
    />
  </span>
</template>

<script>
import { defineComponent } from 'vue'
import DataGetter from '../utils/DataGetter.vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'CurrencyConverter',
  components: { DataGetter, EventListener },
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    srcCurrency: {
      type: String,
      default: 'XOF',
    },
    dstCurrency: {
      type: String,
      default: '',
    },
    useLocalUserCurrency: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rates: {},
      storeData: {},
      localDstCurrency: '',
    }
  },
  mounted() {},
  methods: {
    async externalConvertAmount(
      amount,
      srcCurrency,
      dstCurrency,
      useLocalUserCurrency,
    ) {
      let usedDstCurrency = dstCurrency
      if (useLocalUserCurrency) {
        if (!this.localDstCurrency) await this.loadLocalUserCurrency()
        usedDstCurrency = this.localDstCurrency
      }
      if (srcCurrency == usedDstCurrency) return amount
      return
    },
    convertAmount(amount, src, dst="XOF") {
      if(!this.rates) return 0
      const srcRates = this.rates[src] || {}
      const rateToDst = srcRates[dst]
      if (!rateToDst) return 'Conversion...'
      let converted = amount * rateToDst
      let convertingDecimals = 0
      if (/(eur)|(usd)/i.test(this.usedDstCurrency)) convertingDecimals = 2
      converted = this.$Commons.round(converted, convertingDecimals)
      return converted
    },
  },
  computed: {
    usedDstCurrency() {
      if (this.useLocalUserCurrency) return this.storeData.currency
      return this.dstCurrency
    },
    convertedAmount() {
      if (this.srcCurrency == this.usedDstCurrency) return this.amount
      const converted = this.convertAmount(
        this.amount,
        this.srcCurrency,
        this.usedDstCurrency,
      )
      return converted
    },
  },
  watch: {
    usedDstCurrency(newCurrency){
      this.$emit('dstCurrencyChanged', newCurrency)
    }
  }
})
</script>
